import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
import { problems } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
import { CtaButton } from './CtaButton';
export function Problems() {
  return <section aria-labelledby="problems-heading" className="bg-wine-dark py-16 sm:py-24" data-id="element-291" data-mp="323zlteu5w0gb">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-292" data-mp="2y48th6ozlc9o">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,26rem)_minmax(0,1fr)] lg:gap-20" data-id="element-293" data-mp="2y1mn3adu12t1">
          <div data-id="element-294" data-mp="2t201odnuog95">
            <Eyebrow tone="rose" data-id="element-295" data-mp="2o5jcrh8ttxv0">Rzeczywistość nauczania jazzu</Eyebrow>
            <h2 id="problems-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-5xl" data-id="element-296" data-mp="2o7cnb7mk928a">
              Kochasz uczyć jazzu. <span className="text-amber" data-id="element-297" data-mp="2f663aokpd9aa">To przygotowania Cię wykańczają.</span>
            </h2>
            <p className="mt-6 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-298" data-mp="hea5exdt86li">
              Niedziela, 21:00. Jutro masz sześciu uczniów, sześć różnych poziomów i żadnego jasnego
              planu, co będą ćwiczyć. Więc szukasz tabulatur w internecie, przepisujesz akordy,
              wymyślasz ćwiczenie na szybko… a w następnym tygodniu wszystko od nowa.
            </p>
          </div>
          <div data-id="element-299" data-mp="2vrrjlfc4o94x">
            <ul className="divide-y divide-wine/60" data-id="element-300" data-mp="2vs9o0z8y1tnx">
              {problems.map(problem => <li key={problem} className="flex items-start gap-4 py-5 first:pt-0" data-id="element-301" data-mp="2ztuvg52plfqq">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose-deep" data-id="element-302" data-mp="3ni4krgz4slmm">
                    <XIcon className="h-3.5 w-3.5 text-rose" aria-hidden="true" data-id="element-303" data-mp="3sia66fet5bw9" />
                  </span>
                  <span className="text-base leading-relaxed text-cream-soft" data-id="element-304" data-mp="3iqmjssx3yl1n">{problem}</span>
                </li>)}
            </ul>
            <div className="mt-6 flex items-start gap-4 rounded-2xl border-2 border-rose bg-rose-deep p-5 sm:p-6" data-id="element-305" data-mp="aa17b259p9ts">
              <AlertTriangleIcon className="mt-0.5 h-6 w-6 shrink-0 text-rose" aria-hidden="true" data-id="element-306" data-mp="f3473s0n1fif" />
              <p className="text-base font-semibold leading-snug text-cream sm:text-lg" data-id="element-307" data-mp="owzzizby889k">
                A prawdziwy problem jest taki: uczeń, który się nudzi, nie zapisze się na kolejny
                semestr.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center gap-6 text-center sm:mt-16" data-id="element-308" data-mp="awp6pqr2wjlr">
          <p className="max-w-2xl font-serif text-xl italic leading-snug text-cream sm:text-2xl" data-id="element-309" data-mp="5yxdmtep6rfz">
            To nie brak talentu. To brak planu.{' '}
            <span className="text-amber" data-id="element-310" data-mp="15uiigu9v9xo">A plan jest już gotowy.</span>
          </p>
          <CtaButton size="lg" data-id="element-311" data-mp="3tbzq6f9a1uv3">Chcę skończyć z improwizacją</CtaButton>
        </div>
      </div>
    </section>;
}